<template>
  <div class="col-12">
    <el-card>
      <h4>Product</h4>
      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 44%;
          margin-top: -20px;
          position: absolute;
          z-index: 99;
        "
      >
        <div></div>
        <div style="display: flex; column-gap: 5px">
          <!-- 修改 BillingAddress按钮-->
          <el-link
            v-if="
              useOrder.getOrderFunctionPermission('UpdateProductName')
                ?.enable &&
              IsShowEdit &&
              isUpdateProductionName
            "
            @click="isUpdateProductionName = false"
            style="margin-top: 10px"
            :underline="false"
          >
            <svg-icon style="width: 28px; height: 28px" iconClass="edit" />
          </el-link>
          <!-- 保存 BillingAddress按钮-->
          <el-link
            v-if="IsShowEdit && !isUpdateProductionName"
            @click="UpdateProductName()"
            style="margin-top: 10px"
            :underline="false"
          >
            <svg-icon style="width: 28px; height: 28px" iconClass="save" />
          </el-link>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-7">
          <div style="display: flex; width: 100%" class="input-with-check-box">
            <base-input
              style="width: 100%"
              label="Product / Campaign"
              required
              v-model="Product.productName"
              :disabled="isUpdateProductionName && disabled"
              :class="{
                'is-error': !useOrder.OrderRules.productName.validation,
              }"
            >
            </base-input>

            <base-checkbox v-model="Product.isNewProduct" :disabled="disabled"
              >New Product</base-checkbox
            >
          </div>
        </div>
        <div class="col-sm-5">
          <base-input
            label="Product Category"
            style="width: 100%"
            :required="true"
            :class="{
              'is-error': !useOrder.OrderRules.ProductCategoryIds.validation,
            }"
          >
            <el-select
              ref="ProductSelect"
              v-model="ProductCategoryIds"
              class="select-primary"
              size="large"
              multiple
              filterable
              style="width: 100%"
              placeholder="Product Category"
              @change="checkedCategory"
              :disabled="disabled"
              @remove-tag="removeProductCategory"
              @click="selectCategory"
            >
              <el-option
                v-for="item in useOrder.SelectProductCatOptionals"
                :label="item.lable"
                :value="item.id"
                :key="item.id"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
    </el-card>
  </div>
  {{ OrderProductCatCode }}
</template>

<script setup>
import { StarFilled } from '@element-plus/icons-vue';
import '@/views/order/css/index.css';
import { useOrderStore } from '@/store/order';
import { storeToRefs } from 'pinia';
import { watch, ref, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import { ElMessage } from 'element-plus';
import { useAuthorityStore } from '@/store/authority';
import booknet from '@/network/booknet';
const useAuthority = useAuthorityStore();
const messageConfig = require('@/models/messageConfig.js');
const isUpdateProductionName = ref(true);
const useOrder = useOrderStore();
const { ProductCategoryIds, Product, disabled, Order, Contracts } =
  storeToRefs(useOrder);
//contract是否有上传签署文件
const IsShowEdit = ref(false);

//保存ProductCategoryIds的旧值
var ProductCategoryIds_old = [];
const ProductSelect = ref();
onMounted(() => {
  changIsShowEdit();
  //Product Category显示处理,根据OrderBusinessCategoryIds选择筛选
  selectCategory(false);
  if (useOrder.ProductCategoryList.length > 0) {
    ProductSelect.value.selected = [
      {
        currentLabel:
          useOrder.ProductCategoryList[0].code +
          '-' +
          useOrder.ProductCategoryList[0].name,
      },
    ];
  }
});

// 监听绑定
watch(
  () => useOrder.ProductCategoryIds,
  (newValue, oldValue) => {
    ProductCategoryIds_old = oldValue;
  }
);
//是否显示修改productName按钮
const changIsShowEdit = () => {
  const filteredContracts = Contracts.value.filter(
    (t) => t.status === 'Issued' || t.status === 'Approving'
  );
  if (filteredContracts.length > 0) {
    //SuperAdmin角色不限制
    // const isAdmin = useAuthority.isSuperAdmin();
    // const canUpdateProductName = useAuthority.GetAuthority(
    //   'Form_Order_UpdateProductName_write'
    // );
    IsShowEdit.value =
      filteredContracts.filter((t) => t.signed !== 'Open').length < 1;
    // if (isAdmin || (canUpdateProductName && hasNoSignedContracts)) {
    //   IsShowEdit.value = true;
    // }
  }
};
const checkedCategory = () => {
  //最多选择一个
  if (useOrder.ProductCategoryIds.length > 1) {
    ElMessage({
      message: 'Please select only 1 Product Category!',
      type: 'warning',
    });
    useOrder.ProductCategoryIds = ProductCategoryIds_old;
    return;
  }
  useOrder.changeProductCategory();
};
// const ProductCatOptionals1 = useOrder.ProductCatOptionals;
//单击
const selectCategory = (run) => {
  if (useOrder.OrderBusinessCategoryIds.length != 1) {
    if (run != false) {
      useOrder.SelectProductCatOptionals = [];
      ElMessage({
        message: messageConfig.getMessage('ordercategoryrequire'),
        type: 'warning',
      });
      //失去焦点,隐藏下拉框
      ProductSelect.value.blur();
    }
  } else {
    //根据OrderBusinessCategoryIds选择筛选
    // ProductCatOptionals1.value = useOrder.ProductCatOptionals.filter((p) => {
    //   return (
    //     useOrder.OrderBusinessCategoryIds.indexOf(
    //       p.buesinessCategoryLevelTwoId
    //     ) > -1
    //   );
    // });
    useOrder.SelectProductCatOptionals = useOrder.ProductCatOptionals.filter(
      (p) => {
        return (
          useOrder.OrderBusinessCategoryIds.indexOf(
            p.buesinessCategoryLevelTwoId
          ) > -1
        );
      }
    );
  }
};

// remove: 移除Product Category
const removeProductCategory = () => {
  useOrder.changeProductCategory();
};
//
const UpdateProductName = async () => {
  isUpdateProductionName.value = true;
  const result = await booknet
    .UpdateProductName(Order.value.id, Product.value.productName)
    .then((res) => res.data);
  if (!result.message) {
    ElMessage({
      message: 'Please reprint the contract for client sign back.',
      type: 'success',
    });

    // 更新实体
    var order_entity = useOrder.getOrderData();
    order_entity.updateByCode = result.updateByCode;
    order_entity.updateDate = result.updateDate;
    order_entity.updateByName = result.updateByName;
    useOrder.updateOrder(order_entity);
  } else {
    ElMessage({
      message: result.message,
      type: 'warning',
    });
  }
};
</script>

<style scoped>
.product {
  background-color: #e0e0e0;
}

.text-red {
  color: #f56c6c;
}
</style>
<style scoped>
.choosecontract-item {
  display: flex;
  width: 100%;
}

.choosecontract-item-cell:not(first-child) {
  border-right-width: 0px;
}

.choosecontract-item-cell:last-child {
  border-right-width: 1px;
}

.choosecontract-item:not(first-child) .choosecontract-item-cell {
  border-top-width: 0px;
}

.choosecontract-item:first-child .choosecontract-item-cell {
  border-top-width: 1px;
}

.choosecontract-item-cell {
  padding: 10px;
  border: 1px solid #cecece;
  width: 100%;
}
</style>
<style scoped>
.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

.advertiser-field .form-group.has-label label::after {
  content: '【 Contracting Party 】';
  color: #d05c5f;
}

.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.Rectangle {
  width: 160px;
  height: 32px;
  margin: 20px 1474.6px 0 0;
  padding: 6px 15px 6px 58px;
  border-radius: 6px;
  background-image: linear-gradient(to left, #eb6100, #b60005);
  color: #fff;
}
</style>
